import React from 'react'
import {Breadcrumb} from 'antd'
import {Link, withRouter} from 'react-router-dom'

const MainBreadcrumbs = ({location}) => (
  <Breadcrumb style={{margin: '16px 0'}}>
    {location.pathname.split('/').filter(e => !!e).map(e => (
      <Breadcrumb.Item key={e}><Link to={location.pathname.split(e)[0] + e}>
        {e.charAt(0).toUpperCase() + e.slice(1).replace('-', ' ')}
      </Link></Breadcrumb.Item>
    ))}
  </Breadcrumb>
)

export default withRouter(MainBreadcrumbs)
